import { httpClient } from '@/infra/protocols/http';
import { IHostVoiceDTO } from '@/modules/episodes/dtos/host.dto';
import { HostMapper } from '@/modules/episodes/mappers/host.mapper';

import { type IHostVoice } from '../entities/host.entity';

export namespace PutHostByIdService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
    hostId: number;
  }
  export interface Payload {
    voiceId: number;
    name: string;
  }
  export type Response = IHostVoice;
}

export async function updateHostById(
  params: PutHostByIdService.Params,
  data: PutHostByIdService.Payload,
): Promise<PutHostByIdService.Response> {
  const body = {
    idVoz: data.voiceId,
    nome: data.name,
  };

  const response = await httpClient.put<IHostVoiceDTO>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/hosts/${params.hostId}`,
    body,
  );
  return HostMapper.toPresentation(response);
}
